module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Marker1-19000694358f1fcf8bd2bf5cea7b863b.svg";